import React from 'react';
import { zoneCalc } from '../../utils/zoneCalc';
import _ from 'lodash';
import {countFilter, playerTypeFilter} from '../../utils/filter/dataFilter';
import colorCalcObj from '../../utils/color/colorCalc';
import statCalc from '../../utils/stat/statCalc';
import { useTranslation } from 'react-i18next';

function HitLocationChart({data, checkObj, hitCheckObj, colorType, filter, playerType, battingHand}) {
    const { t } = useTranslation();

    const ballCodeArr = [
        {name: 'fastball', code: 6116, color: '#ff0000'}, {name: 'sinker', code: 6101, color: '#ff7800'}, 
        {name: 'cutter', code: 6117, color: '#00ff00'}, {name: 'slider', code:6111, color: '#00aa00'},
        {name: 'curve', code: 6108, color: '#000000'}, {name: 'changeup', code: 6103, color: '#0000ff'}, 
        {name: 'splitter', code: 6107, color: '#a01ff0'}, {name: 'other', code:6199, color: '#ececec'}
    ]

    // if(data.length === 0) {
    //     return (
    //         <div>
    //             <div style={{textAlign:'center', width:'260px', height:'170px', 
    //             display: 'flex',justifyContent: 'center', alignItems: 'center'}}>
    //                 No Data
    //             </div>
    //             <div style={{textAlign:'center'}}>{t(title)}</div>
    //         </div>
    //     )
    // }

    // 체크박스 선택 여부에 따라 필터링
    let checkedData = _.filter(data, (item, idx) => {
        let condi = false;
        if(checkObj[item['ballCode']] && hitCheckObj[item['hitResultCode']]) {
            condi = true;
        }

        return condi;
    });

    // 투구 좌표 구하기
    let pitchData = zoneCalc(180, 180, checkedData, playerType);

    let width = 180;
    let height = 200;
    let perWidth = width/5;
    let halfWidth = width/2;

    if(playerType === 'batter') { // reverse
        if(battingHand === 'R') {
            // leftImagePath = 'blue_l.png';
            // rightImageHidden = 'none';
        } else {
            // rightImagePath = 'blue_r.png';
            // leftImagePath = 'none';
        }
    } else { // pitcher
        if(filter['type'] === 'R') {
            // rightImagePath = 'blue_r.png';
            // leftImagePath = 'none';
        } else if(filter['type'] === 'L') {
            // leftImagePath = 'blue_l.png';
            // rightImagePath = 'none';
        } else {

        }
    }

    let plateType = (playerType === 'batter') ? 'homeplate_small.png' : 'homeplate_small_rotate.png';

    function ballCodeColorHandler(ballCode) {
        let ballCodeObj = _.find(ballCodeArr, (item) => (item['code'] === ballCode));

        if(ballCodeObj) {
            return ballCodeObj['color'];
        } else {
            return '#ffffff';
        }
    }

    return (
    <>
    {/* <div style={{textAlign:'center'}}> */}
        <svg width="260" height="330">
            <g transform='translate(70,85)'>
                <path id="z_11" d={`M0,0L${halfWidth},0L${halfWidth},${perWidth}L${perWidth},${perWidth}L${perWidth},${halfWidth}L0,${halfWidth}L0,0`}
                fill={"rgb(255, 255, 255)"} stroke="darkgray" strokeWidth={1}></path>

                <path id="z_12" d={`M${halfWidth},0L${width},0L${width},${halfWidth}L${perWidth*4},${halfWidth}L${perWidth*4},${perWidth}L${halfWidth},${perWidth}L${halfWidth},0`} 
                fill={"rgb(255, 255, 255)"} stroke="darkgray" strokeWidth={1}></path>
                
                <path id="z_13" d={`M0,${halfWidth}L0,${width}L${halfWidth},${width}L${halfWidth},${perWidth*4}L${perWidth},${perWidth*4}L${perWidth},${halfWidth}L0,${halfWidth}`} 
                fill={"rgb(255, 255, 255)"} stroke="darkgray" strokeWidth={1}></path>
                
                <path id="z_14" d={`M${halfWidth},${perWidth*4}L${perWidth*4},${perWidth*4}L${perWidth*4},${halfWidth}L${width},${halfWidth}L${width},${width}L${halfWidth},${width}L${halfWidth},${perWidth*4}`} 
                fill={"rgb(255, 255, 255)"} stroke="darkgray" strokeWidth={1}></path>

                <path id="z_1" d={`M${perWidth},${perWidth}L${perWidth*2},${perWidth}L${perWidth*2},${perWidth*2}L${perWidth},${perWidth*2}`} 
                fill={"rgb(239, 239, 239)"} stroke="darkgray" strokeWidth={1}></path>
                
                <path id="z_2" d={`M${perWidth*2},${perWidth}L${perWidth*3},${perWidth}L${perWidth*3},${perWidth*2}L${perWidth*2},${perWidth*2}`} 
                fill={"rgb(239, 239, 239)"} stroke="darkgray" strokeWidth={1}></path>
                
                <path id="z_3" d={`M${perWidth*3},${perWidth}L${perWidth*4},${perWidth}L${perWidth*4},${perWidth*2}L${perWidth*3},${perWidth*2}`} 
                fill={"rgb(239, 239, 239)"} stroke="darkgray" strokeWidth={1}></path>
                
                <path id="z_4" d={`M${perWidth},${perWidth*2}L${perWidth*2},${perWidth*2}L${perWidth*2},${perWidth*3}L${perWidth},${perWidth*3}`} 
                fill={"rgb(239, 239, 239)"} stroke="darkgray" strokeWidth={1}></path>
                
                <path id="z_5" d={`M${perWidth*2},${perWidth*2}L${perWidth*3},${perWidth*2}L${perWidth*3},${perWidth*3}L${perWidth*2},${perWidth*3}`} 
                fill={"rgb(239, 239, 239)"} stroke="darkgray" strokeWidth={1}></path>
                
                <path id="z_6" d={`M${perWidth*3},${perWidth*2}L${perWidth*4},${perWidth*2}L${perWidth*4},${perWidth*3}L${perWidth*3},${perWidth*3}`} 
                fill={"rgb(239, 239, 239)"} stroke="darkgray" strokeWidth={1}></path>
                
                <path id="z_7" d={`M${perWidth},${perWidth*3}L${perWidth*2},${perWidth*3}L${perWidth*2},${perWidth*4}L${perWidth},${perWidth*4}`} 
                fill={"rgb(239, 239, 239)"} stroke="darkgray" strokeWidth={1}></path>
                
                <path id="z_8" d={`M${perWidth*2},${perWidth*3}L${perWidth*3},${perWidth*3}L${perWidth*3},${perWidth*4}L${perWidth*2},${perWidth*4}`} 
                fill={"rgb(239, 239, 239)"} stroke="darkgray" strokeWidth={1}></path>
                
                <path id="z_9" d={`M${perWidth*3},${perWidth*3}L${perWidth*4},${perWidth*3}L${perWidth*4},${perWidth*4}L${perWidth*3},${perWidth*4}`} 
                fill={"rgb(239, 239, 239)"} stroke="darkgray" strokeWidth={1}></path>
                
                {pitchData?.map((item, idx) => (
                    item['pitch_x'] && 
                    <circle
                        key={"circle_"+item['gameRecordId']}
                        id={item['gameRecordId']}
                        cx={item['pitch_x']}
                        cy={item['pitch_y']}
                        r="5"
                        fill={(colorType === 'hitResult') ? item['color'] : ballCodeColorHandler(item['ballCode'])} // 타격 결과에 따른 색상도 추가 필요
                        opacity="1"
                        stroke="black"
                    ></circle>
                ))}
            </g>
            <g transform='translate(135,285)'>
                <image href={`${process.env.PUBLIC_URL}/image/${plateType}`} width={50}/>
            </g>
        </svg>
    {/* </div> */}
    </>
    );
}

export default HitLocationChart;